import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import FormMf from '../form/FormExamens';
import { useLoader } from '../context/LoaderContext'
import * as Services from '../services/Services';

declare global {
  interface Window {
    Liferay: any; // Puedes definir 'any' o crear una estructura más específica si conoces las propiedades
  }
}

interface FormContextProps {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    stateCompany: boolean;
    setStateCompany: (stateCompany: boolean) => void;
    backgroundColor: string;
    setBackgroundColor: (backgroundColor: string) => void;
    dataCards: any;
    setDataCards: ({data}: {data: any}) => void;
    selectedOption: string;
    setSelectedOption: (selectedOption: string) => void;
    first: number;
    setFirst: (first: number) => void;
    rows: number;
    setRows: (rows: number) => void;
    cupsCode: string;
    setCupsCode: (cupsCode: string) => void;
    codLaboratory: string;
    setcodLaboratory: (codLaboratory: string) => void;
    nameValue: string;
    setNameValue: (nameValue: string) => void;
    customMessage: string;
    setCustomMessage: (customMessage: string) => void;
    handleCupsCode: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleCodLaboratory: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleName: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleOption: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    handleKeyDown: (event: React.KeyboardEvent, option: string) => void;
    handleButtonClickCards: (index: number) => void;
    onPageChange: (event: any) => void;
    dataTypeDocument: any;
    fetchData: (tokenMiddleWare: string) => void;
    fetchDataTitle: (tokenMiddleWare: string) => void;
    liferayId: string;
    setLiferayId: (liferayId: string) => void;
    typeOfSearch: string;
    setTypeOfSearch: (typeOfSearch: string) => void;
    dataTitles: any;
    sampleNames: any;
    cupsCodeData: any;
    codeLaboratoryData: any;
    setUserId: (userId: string) => void;
    tokenMw: string;
    getTokenMw: () => void;
    getDocumentType: (tokenMiddleWare: string) => void;
    getSampleName: (tokenMiddleWare: string) => void;
    getCodeLaboratory: (tokenMiddleWare: string) => void;
    getCupsCode: (typeOfSearch: string, tokenMiddleWare: string) => void;
}

const FormContext = createContext<FormContextProps | undefined>(undefined);

export const FormProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const [stateCompany, setStateCompany] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState('');
  const [dataCards, setDataCards] = useState({data: []});
  const [dataTypeDocument, setDataTypeDocument] = useState([]);
  const [selectedOption, setSelectedOption] = useState<string>('');
  const [selectedOptionSearch, setSelectedOptionSearch ] = useState<string>('');
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(9);
  const [cupsCode, setCupsCode] = useState<string>('');
  const [codLaboratory, setcodLaboratory] = useState<string>('');
  const [nameValue, setNameValue] = useState<string>('');
  const [customMessage, setCustomMessage] = useState('');
  const [typeOfSearch, setTypeOfSearch] = useState('');
  const [dataTitles, setDataTitles] = useState([]);
  const [liferayId, setLiferayId] = useState('');
  const [userId, setUserId] = useState('');
  const [sampleNames, setSampleNames] = useState([{}]);
  const [cupsCodeData, setCupsCodeData] = useState([{}]);
  const [codeLaboratoryData, setCodeLaboratoryData] = useState([{}]);
  const [tokenMw, setTokenMw] = useState('');

  const { showLoader, hideLoader } = useLoader() 
  
  const onPageChange = (event: any) => {
    setFirst(event.first);
    setRows(event.rows);
  };

   useEffect(() => {
    const themeDisplay = window?.Liferay?.ThemeDisplay;

    if (themeDisplay) {
    setLiferayId(themeDisplay.getSiteGroupId());

    const layoutURL = themeDisplay.getLayoutRelativeControlPanelURL();

    if (
      layoutURL.includes("/personas/") || 
      layoutURL === '/group/personas/~/control_panel/manage'
    ) {
      setStateCompany(true);
      setTypeOfSearch('person');
    } else if (
      layoutURL.includes("/empresas/") || 
      layoutURL === '/group/empresas/~/control_panel/manage'
    ) {
      setStateCompany(false);
      setTypeOfSearch('company');
    }
  } else {
    console.warn("Liferay.ThemeDisplay is not available");
  }
  }, []);  
  
  useEffect(() => {
    if (liferayId && typeOfSearch) {
      const functionToken = async () => {
        const [token] = await Promise.all([getTokenMw()]);
        getCupsCode(token);
        getCodeLaboratory(token);
        fetchDataTitle(token);
        getDocumentType(token);
        getSampleName(token);
      };
      const timer = setTimeout(functionToken, 300);
      return () => clearTimeout(timer);
    }
  }, [liferayId, typeOfSearch]); 

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const handleResize = (event: MediaQueryListEvent) => {
        setRows(event.matches ? 6 : 9);
    };

    // Set initial rows based on the current window size
    setRows(mediaQuery.matches ? 6 : 9);

    mediaQuery.addEventListener('change', handleResize);

    return () => {
        mediaQuery.removeEventListener('change', handleResize);
    };
  }, []);    

  const handleCupsCode = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setCupsCode(value);
  };

  const handleCodLaboratory = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    event.target.value = value.replace(/[^0-9]/g, '');
    setcodLaboratory(event.target.value);
  };

  const handleName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNameValue(event.target.value);
  };

  const handleOption = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedText = event.target.id;
    const truncatedText = selectedText.length > 35 ? selectedText.substring(0, 35) + '...' : selectedText;
    setSelectedOption(truncatedText);
    setSelectedOptionSearch(event.target.id)
  };
  
  const handleKeyDown = (event: React.KeyboardEvent, option: string) => {
    if (event.key === 'Enter') {
      setSelectedOption(option);
    }
  };

  const handleButtonClickCards = (index: number) => {
    sessionStorage.setItem('cardData', JSON.stringify(dataCards));
    window.location.href = '/web/empresas/buscador-de-examenes-detalle';
  };

  const getTokenMw = async () => {
    try {
      const response = await Services.getTokenMw();
      const tokenMiddleWare = response.data.token;
      if (response.status === 200 || response.status === 201) {
        setTokenMw(tokenMiddleWare); // Asegúrate de que esta función sea síncrona
      }
      return tokenMiddleWare;
    } catch (error) {
      console.error("Error en la autenticación", error);
    }
  };


  const getDocumentType = (tokenMiddleWare: string) => {
    Promise.all([Services.getDocumentType(typeOfSearch, tokenMiddleWare)])
      .then((responses) => {
        const response: any = responses[0];
        const dataInfolaft = response.data.data;
        if (response.status === 200 || response.status === 201) {
          setDataTypeDocument(dataInfolaft);
        }
      })
      .catch((error) => {
        console.error("Error en la autenticación", error);
      });
  }

  const getSampleName = (tokenMiddleWare: string) => {
    Promise.all([Services.getSampleName(typeOfSearch, tokenMiddleWare)])
      .then((responses) => {
        const response: any = responses[0];
        const dataInfolaft = response.data.data;
        if (response.status === 200 || response.status === 201) {
          setSampleNames(dataInfolaft);
        }
      })
      .catch((error) => {
        console.error("Error en la autenticación", error);
      });
  }

  const getCupsCode = (tokenMiddleWare: string) => {
    Promise.all([Services.getCupsCode(typeOfSearch, tokenMiddleWare)])
      .then((responses) => {
        const response: any = responses[0];
        const dataInfolaft = response.data.data;
        if (response.status === 200 || response.status === 201) {
          setCupsCodeData(dataInfolaft);
        }
      })
      .catch((error) => {
        console.error("Error en la autenticación", error);
      });
  }

  const getCodeLaboratory = (tokenMiddleWare: string) => {
    Promise.all([Services.getCodeLaboratory(tokenMiddleWare)])
      .then((responses) => {
        const response: any = responses[0];
        const dataInfolaft = response.data.data;
        if (response.status === 200 || response.status === 201) {
          setCodeLaboratoryData(dataInfolaft);
        }
      })
      .catch((error) => {
        console.error("Error en la autenticación", error);
      });
  }

  const fetchData = (tokenMiddleWare: string) => {
    showLoader();
    Promise.all([Services.postDataUser(typeOfSearch, tokenMiddleWare, cupsCode, codLaboratory, selectedOptionSearch, nameValue)])
      .then((responses) => {
        const response: any = responses[0];
        const dataInfolaft = response.data.data;
        if (response.status === 400 || response.status === 401){
          setDataCards({data: []});
          getTokenMw();
          hideLoader();
          setVisible(false);
        }
        if (response.status === 200 || response.status === 201 || response.status === 204) {
          setDataCards(dataInfolaft);
          fetchDataTitle(tokenMiddleWare);
          hideLoader();
          setVisible(true);
        }
        hideLoader();
      })
      .catch((error) => {
        console.error("Error en la autenticación", error);
        hideLoader();
      });
  }

  const fetchDataTitle = (tokenMiddleWare: string) => {
    Promise.all([Services.getTitles(liferayId, tokenMiddleWare)])
      .then((responses) => {
        const response: any = responses[0];
        const dataInfolaft = response.data.data;
        if (response.status === 200 || response.status === 201) {
          setDataTitles(dataInfolaft);
        }
      })
      .catch((error) => {
        console.error("Error en la autenticación", error);
      });
  }

  return (
    <FormContext.Provider
      value={{
        visible,
        setVisible,
        stateCompany,
        setStateCompany,
        backgroundColor,
        setBackgroundColor,
        dataCards,
        setDataCards,
        selectedOption,
        setSelectedOption,
        first,
        setFirst,
        rows,
        setRows,
        cupsCode,
        setCupsCode,
        codLaboratory,
        setcodLaboratory,
        nameValue,
        setNameValue,
        customMessage,
        setCustomMessage,
        handleCupsCode,
        handleCodLaboratory,
        handleName,
        handleOption,
        handleKeyDown,
        handleButtonClickCards,
        onPageChange,
        dataTypeDocument,
        fetchDataTitle,
        fetchData,
        liferayId,
        setLiferayId,
        dataTitles,
        typeOfSearch,
        setTypeOfSearch,
        sampleNames,
        cupsCodeData,
        codeLaboratoryData,
        setUserId,
        tokenMw,
        getTokenMw,
        getDocumentType,
        getSampleName,
        getCodeLaboratory,
        getCupsCode,
      }}
    >
      {children}
      </FormContext.Provider>
  );
};

export const useFormContext = () => {
  const context = useContext(FormContext);
  if (context === undefined) {
    throw new Error('useFormContext must be used within a FormProvider');
  }
  return context;
};

export default FormContext